import { Directive, DirectiveBinding } from "vue";

interface HTMLElementWithClickOutsideEvent extends HTMLElement {
  __clickOutsideEvent?: (event: MouseEvent) => void;
}

const clickOutsideDirective: Directive = {
  mounted(el: HTMLElementWithClickOutsideEvent, binding: DirectiveBinding) {
    const clickOutsideEvent = function (event: MouseEvent) {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value(event, el);
      }
    };

    el.__clickOutsideEvent = clickOutsideEvent;
    document.body.addEventListener("click", clickOutsideEvent);
  },

  beforeUnmount(el: HTMLElementWithClickOutsideEvent) {
    const clickOutsideEvent = el.__clickOutsideEvent;
    if (clickOutsideEvent) {
      document.body.removeEventListener("click", clickOutsideEvent);
      delete el.__clickOutsideEvent;
    }
  },
};

export default clickOutsideDirective;

// usage
// <span v-outside="handleClickOutside">click</span>
